var chunkMapping = {
	"src_bootstrap_tsx": [
		"webpack/container/remote/HomeMicrofrontend/LandingPage"
	],
	"webpack_container_remote_QuoterMicrofrontend_Quoter": [
		"webpack/container/remote/QuoterMicrofrontend/Quoter"
	],
	"webpack_container_remote_QuoterMicrofrontend_QuoterForm": [
		"webpack/container/remote/QuoterMicrofrontend/QuoterForm"
	],
	"webpack_container_remote_QuoterMicrofrontend_QuoterOffer": [
		"webpack/container/remote/QuoterMicrofrontend/QuoterOffer"
	],
	"webpack_container_remote_QuoterMicrofrontend_QuoterCustomizeOffer": [
		"webpack/container/remote/QuoterMicrofrontend/QuoterCustomizeOffer"
	],
	"webpack_container_remote_QuoterMicrofrontend_QuoterOrigination": [
		"webpack/container/remote/QuoterMicrofrontend/QuoterOrigination"
	],
	"webpack_container_remote_QuoterMicrofrontend_QuoterThanks": [
		"webpack/container/remote/QuoterMicrofrontend/QuoterThanks"
	],
	"webpack_container_remote_QuoterMicrofrontend_QuoterApprovedLoan": [
		"webpack/container/remote/QuoterMicrofrontend/QuoterApprovedLoan"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/HomeMicrofrontend/LandingPage": [
		"default",
		"./LandingPage",
		"webpack/container/reference/HomeMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/Quoter": [
		"default",
		"./Quoter",
		"webpack/container/reference/QuoterMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/QuoterForm": [
		"default",
		"./QuoterForm",
		"webpack/container/reference/QuoterMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/QuoterOffer": [
		"default",
		"./QuoterOffer",
		"webpack/container/reference/QuoterMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/QuoterCustomizeOffer": [
		"default",
		"./QuoterCustomizeOffer",
		"webpack/container/reference/QuoterMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/QuoterOrigination": [
		"default",
		"./QuoterOrigination",
		"webpack/container/reference/QuoterMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/QuoterThanks": [
		"default",
		"./QuoterThanks",
		"webpack/container/reference/QuoterMicrofrontend"
	],
	"webpack/container/remote/QuoterMicrofrontend/QuoterApprovedLoan": [
		"default",
		"./QuoterApprovedLoan",
		"webpack/container/reference/QuoterMicrofrontend"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}